import * as React from "react";
import {Stylable} from "../common/PropsType";

import "./vebox-card.scss";
import {Display} from "../Display";

interface HeaderProps extends Stylable {
    title: string;
    titleClassName?: string;
    singleLineTitle?: boolean;
    front?: React.ReactNode;
    back?: React.ReactNode;
}

export class VeBoxCard extends React.Component<Stylable> {

    public static Header: React.FC<HeaderProps> = (props) => (
        <div className={"vebox-card-header " + (props.className ?? "")} style={props.style}>
            <Display isVisible={props.front}>
                <div className={"vebox-card-header-front"}>
                    {props.front}
                </div>
            </Display>
            <div
                className={"vebox-card-header-title "
                    + (props.titleClassName ?? "")
                    + (props.singleLineTitle ? " vebox-card-one-line-title" : "")}
            >
                <h2>{props.title}</h2>
            </div>
            <Display isVisible={props.back}>
                <div className={"vebox-card-header-back"}>
                    {props.back}
                </div>
            </Display>
        </div>
    )

    public static Body: React.FC<Stylable> = (props) => (
        <div className={"vebox-card-body " + (props.className ?? "")} style={props.style}>
            {props.children}
        </div>
    )

    public static Footer: React.FC<React.HTMLAttributes<any>> = (props) => (
        <div {...props} className={"vebox-card-footer " + (props.className ?? "")}>
            {props.children}
        </div>
    )

    public render() {
        return (
            <div className={"vebox-card " + (this.props.className ?? "")} style={this.props.style}>
                {this.props.children}
            </div>
        );
    }
}